export default __webpack_public_path__ + "static/media/toyota-quantum.a16a457b.png";